import { createStyles } from '@mantine/core';

var useStyles = createStyles(() => ({
  calendar: {}
}));

export default useStyles;
//# sourceMappingURL=Calendar.styles.js.map
